module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion3_en_m.78fc57150b1398401a2069f87c951992.png";